import * as React from 'react';
import Well from '../well/well';
export var ReachWell = function ReachWell(props) {
  var className = props.className,
      children = props.children,
      actions = props.actions;
  return /*#__PURE__*/React.createElement(Well, {
    className: className,
    title: "Audience Size",
    hideFooter: true,
    actions: actions
  }, children);
};